<p-tabView (onChange)="onTabChange($event)">
    <p-tabPanel header="Overview">
        <div class="container" id="billPreview">
            <div class="card">
                <div class="p-field p-formgrid p-grid">
                    <div style="width: 33%; display: inline-block; vertical-align: top;">
                        <div class="p-fluid">
                            <div class="card" style="min-height: 135px;">
                                <h6 class="p-mb-0">Vendor Information</h6>
                                <p>{{billPayDetails?.vendorBusinessName}}</p>
                                <p>{{ordersVendorAddr}}<span *ngIf="ordersVendorAddr !== ''">,</span></p>
                                <p>
                                    {{ordersVendorCity}}<span *ngIf="ordersVendorCity !== ''">, </span> {{ordersVendorState}}
                                    <span *ngIf="ordersVendorState !== ''">, </span> {{ordersVendorCountry}}
                                    <span *ngIf="ordersVendorCountry !== ''">, </span> {{ordersVendorZipcode}}
                                </p>
                                <p>{{ordersVendorContactNew}}</p>
                                <p>{{ordersVendorPhoneNew}}</p>
                            </div>
                        </div>
                    </div>
                    <div style="width: 33%; display: inline-block; vertical-align: top;">
                        <div class="p-fluid">
                            <div class="card" style="min-height: 135px;">
                                <p style="margin-top: 13px;">Payment Receipt No.: {{billPayDetails?.number}}</p>
                                <p>Payment Term.: {{billPayDetails?.paymentTerm?.name}}</p>
                                <p>Payment Method: {{billPayDetails?.paymentMethod?.name}}</p>
                                <p>Payment Receipt Date: {{billPayDetails?.billDate | date: 'MM/dd/yyyy'}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-field p-formgrid p-grid">
                    <div class="p-col-12">
                        <p-table [value]="billDetailsData" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Bill No.</th>
                                    <th>Bill Date</th>
                                    <th>Total Amount</th>
                                    <th>Paid Amount</th>
                                    <th id="credit">Applied Credit</th>
                                    <th>Discount Amount</th>
                                    <th>Due Amount</th>
                                    <th>Status</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-bill let-index="rowIndex">
                                <tr>
                                    <td>{{bill?.billNo}}</td>
                                    <td>{{bill?.rpodate}}</td>
                                    <td>{{bill?.amount | customNumberFormat: length| currencySymbol}}</td>
                                    <td>{{bill?.paidamount | customNumberFormat: length| currencySymbol}}</td>
                                    <td>{{bill.appliedCredit | customNumberFormat: length | currencySymbol}}</td>
                                    <td>{{bill?.discountamount | customNumberFormat: length| currencySymbol}}</td>
                                    <td>{{bill?.dueamount | customNumberFormat: length| currencySymbol}}</td>
                                    <td>{{bill?.status}}</td>
                                </tr>
                            </ng-template>
                            <tr>
                                <td colspan="7" style="text-align: right; border: 1px solid #333; padding: 5px 8px;">{{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[0].labelname}}
                                </td>
                                <td colspan="3">{{billPayDetails?.subTotal | customNumberFormat: length| currencySymbol}}</td>
                            </tr>
                            <tr *ngIf="billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[2].isChecked">
                                <td colspan="7" style="text-align: right; border: 1px solid #333; padding: 5px 8px;">{{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[1].labelname}}
                                </td>
                                <td colspan="3">
                                    {{billPayDetails?.discountAmount | customNumberFormat: length| currencySymbol}}
                                </td>
                            </tr>
                            <tr *ngIf="billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[1].isChecked && billPayDetails?.discountAmount>0">
                                <td colspan="7" style="text-align: right; border: 1px solid #333; padding: 5px 8px;">
                                    {{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[2].labelname}}
                                </td>
                                <td colspan="3">{{billPayDetails?.discountAccount}}</td>
                            </tr>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
        
        <div *ngIf="!isView">
            <app-addedit-billpay [savedBillPayment]="billPayDetails" [bankAccounts]="bankAccounts" [financialAccounts]="financialAccounts"
           [decimalLength]="length" (closeDialog)="updateJournal()" (hideDialog)="cancel()"></app-addedit-billpay>
        </div>
        
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="billPayId" [objectTypeId]="transactionTypeIds.BillPay" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>

